import { render, staticRenderFns } from "./codeparrainage.vue?vue&type=template&id=d1034926&scoped=true"
import script from "./codeparrainage.vue?vue&type=script&lang=js"
export * from "./codeparrainage.vue?vue&type=script&lang=js"
import style0 from "./codeparrainage.vue?vue&type=style&index=0&id=d1034926&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d1034926",
  null
  
)

export default component.exports